export const hasOwnProperty = <ObjectType extends Record<string, any>>(
  object: ObjectType,
  property: PropertyKey
): object is ObjectType & Record<PropertyKey, unknown> =>
  object && Object.prototype.hasOwnProperty.call(object, property);
